import images from "./images";

const portfolio = [
    {
        id: 1,
        image: images.portfolio1,
        title: "Wedding Feast",
        details: {
            date: "February 14, 2024",
            category: "Event Catering",
            headChef: "John Doe",
            duration: "4 hours",
            location: "Grand Ballroom, City Hotel",
            admission: "By Invitation Only",
            eventPlanner: "Jane Smith"
        },
        paragraphs: [
            "Celebrate your special day with an exquisite wedding feast, meticulously crafted to create unforgettable memories. Our team of expert chefs and event planners will ensure every detail is perfect, from the first bite to the last toast.",
            "Experience the joy of your wedding day with a feast that embodies elegance, taste, and celebration. Our carefully curated menu offers a delightful blend of flavors, showcasing the finest ingredients and culinary artistry to make your event truly remarkable."
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6
        ],
        highlights: [
            "Personalized menus crafted to your taste and preferences",
            "Elegant presentation and attention to detail",
            "Professional service and seamless execution"
        ],
        solutions: [
            "Coordinating multiple dietary requirements and preferences",
            "Ensuring timely and efficient service",
            "Maintaining the highest standards of food quality and safety"
        ],
        benefits: [
            "Exceptional culinary experience",
            "Memorable and personalized celebration",
            "Stress-free planning and execution"
        ]
    },
    {
        id: 2,
        image: images.portfolio2,
        title: "Signature Dishes",
        details: {
            date: "March 10, 2024",
            category: "Menu Creation",
            headChef: "Emma Brown",
            duration: "2 Weeks",
            location: "Classic Feast Test Kitchen",
            admission: "Private Session",
            eventPlanner: "Liam Carter"
        },
        paragraphs: [
            "Crafting a menu of signature dishes involves blending creativity with culinary excellence. Our menu creation process focuses on developing standout items that define the essence of the brand and leave a lasting impression.",
            "From flavor profiling to plating aesthetics, each dish is refined through multiple iterations to achieve perfection. Signature dishes serve as a hallmark of your dining experience, making your restaurant truly memorable."
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6
        ],
        highlights: [
            "Original recipes crafted in-house",
            "Balanced flavors and modern presentation",
            "Consistent quality and visual appeal"
        ],
        solutions: [
            "Developed standout items to define brand identity",
            "Tested multiple flavor profiles to ensure customer satisfaction",
            "Streamlined kitchen operations for consistent dish quality"
        ],
        benefits: [
            "Unique menu that attracts new customers",
            "Signature dishes that boost brand recognition",
            "Increased customer retention and loyalty"
        ]
    },
    {
        id: 3,
        image: images.portfolio3,
        title: "Private Dinner",
        details: {
            date: "May 5, 2024",
            category: "Event Catering",
            headChef: "Olivia Martin",
            duration: "3 Hours",
            location: "Client’s Private Residence",
            admission: "By Reservation Only",
            eventPlanner: "Ethan Cole"
        },
        paragraphs: [
            "Indulge in an intimate and luxurious private dinner experience tailored to your taste. Our catering team creates a refined culinary journey perfect for anniversaries, proposals, or exclusive gatherings.",
            "Every element—from curated menus to elegant tablescapes—is handled with precision and style. With personalized service and gourmet flavors, we turn your private dinner into an unforgettable celebration."
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6
        ],
        highlights: [
            "Bespoke multi-course menus",
            "Luxury setup and ambiance",
            "Discreet and attentive service"
        ],
        solutions: [
            "Customized dishes for dietary preferences",
            "On-site coordination with minimal disruption",
            "Elegant plating and professional staff"
        ],
        benefits: [
            "Exclusive and memorable dining experience",
            "Personalized service in a private setting",
            "Stress-free planning with high-end results"
        ]
    },
    {
        id: 4,
        image: images.portfolio4, // Replace with your actual image reference
        title: "Outdoor Feast",
        details: {
            date: "June 10, 2024",
            category: "Banquet Setup",
            headChef: "Liam Brooks",
            duration: "5 Hours",
            location: "Hilltop Garden Venue",
            admission: "Open Reservation",
            eventPlanner: "Sophie Turner"
        },
        paragraphs: [
            "Experience the charm of al fresco dining with our Outdoor Feast setup—perfect for weddings, reunions, and seasonal celebrations. Surrounded by nature, this setup blends gourmet cuisine with open-air elegance.",
            "From rustic decor to ambient lighting, our team ensures every detail enhances the outdoor experience. Guests can enjoy a relaxed, luxurious banquet while savoring handcrafted dishes made from the freshest ingredients."
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6
        ],
        highlights: [
            "Scenic and spacious outdoor setting",
            "Custom banquet-style arrangements",
            "Atmospheric lighting and decor"
        ],
        solutions: [
            "Weather-contingency planning",
            "Outdoor cooking and buffet stations",
            "On-site coordination for seamless flow"
        ],
        benefits: [
            "Fresh air and scenic ambiance",
            "Perfect blend of comfort and style",
            "Ideal for large gatherings and celebrations"
        ]
    },
    {
        id: 5,
        image: images.portfolio5, // Replace with your actual image path
        title: "Healthy Choices",
        details: {
            date: "July 5, 2024",
            category: "Menu Creation",
            headChef: "Ava Martinez",
            duration: "3 Hours",
            location: "Wellness Retreat Center",
            admission: "Pre-Registration Required",
            eventPlanner: "Daniel Carter"
        },
        paragraphs: [
            "Our 'Healthy Choices' menu is designed to provide nutritious, flavorful dishes without compromising on taste. Whether it's for a wellness event or a fitness-themed gathering, these options cater to mindful eating preferences.",
            "From colorful salads and lean proteins to vegan delights and detox drinks, every dish is thoughtfully prepared to support health-conscious lifestyles while delivering exceptional flavor."
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6
        ],
        highlights: [
            "Low-calorie, nutrient-rich meals",
            "Plant-based and gluten-free options",
            "Naturally sweetened beverages and desserts"
        ],
        solutions: [
            "Customizable menu for dietary needs",
            "Ingredient transparency and labeling",
            "Balanced portions for optimal nutrition"
        ],
        benefits: [
            "Supports health and wellness goals",
            "Encourages conscious eating habits",
            "Delivers taste without guilt"
        ]
    },
    {
        id: 6,
        image: images.portfolio6, // Replace with your actual image path
        title: "Formal Banquet",
        details: {
            date: "August 2, 2024",
            category: "Banquet Setup",
            headChef: "Charles Bennett",
            duration: "5 Hours",
            location: "Crystal Hall, City Convention Center",
            admission: "By Reservation Only",
            eventPlanner: "Sophia Reynolds"
        },
        paragraphs: [
            "Our 'Formal Banquet' setup is a testament to timeless elegance and meticulous planning. Designed for galas, awards ceremonies, and high-profile gatherings, this banquet features a luxurious atmosphere paired with gourmet dining.",
            "From crystal table settings and ambient lighting to a multi-course menu crafted by our culinary experts, every detail of this formal event aims to impress and elevate the guest experience."
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6
        ],
        highlights: [
            "Elegant table arrangements and centerpieces",
            "Multi-course gourmet menu",
            "Dedicated serving staff and event coordination"
        ],
        solutions: [
            "Tailored themes and table layouts",
            "Seamless service flow for large guest counts",
            "Detailed timeline and event execution plan"
        ],
        benefits: [
            "Sophisticated and memorable ambiance",
            "High-end dining experience",
            "Flawless execution for prestigious occasions"
        ]
    }
];

export default portfolio;